// @flow
// YYYY-MM-DD
import { dateRangeData } from "../../pages/Dashboard/dbConstants";
import {
  ADD_ACTIONABLE_POP_UP,
  ADD_CHARGER_TO_LOCATION_MAP,
  ADD_TOAST_MESSAGE,
  CHANGE_DATERANGE,
  CHANGE_LOCATION,
  CHANGE_PROJECT,
  POPUP_CONFIRM,
  REMOVE_ACTIONABLE_POP_UP,
  REMOVE_TOAST_MESSAGE,
  RESET_FILTER,
  RESET_REPORT_DATA,
  UPDATE_REPORT_DATA,
} from "./actionTypes";
const today = new Date();
const firstDayOfMonth = new Date("2024-01-01");
const INIT_STATE = {
  dateRange: null,
  location: null,
  report:null,
  // project: null,
  toast: [],
  popUp: [],
  chargerToLocationMap: [],
};

const sharedData = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_REPORT_DATA:
      return {
        ...state,
        dateRange: action.payload.dateRange,
        location: action.payload.location,
        report:action.payload.report
      };
    case RESET_REPORT_DATA:
      return {
        ...state,
        location: null,
        dateRange: null,
        report:null,
      };
    // case CHANGE_PROJECT:
    //   console.log("location", action.payload);

    //   return {
    //     ...state,
    //     project: action.payload,
    //   };
    case RESET_FILTER:
      return {
        toast: [],
        popUp: [],
        chargerToLocationMap: [],
        location: null,
        dateRange: null,
        report:null,

      };
    case ADD_TOAST_MESSAGE:
      const { toast } = state;
      const { type, title, message } = action?.payload;
      const height = toast?.length + 1;
      const selectedToast = {
        id: Date.now(),
        type: type,
        title: title,
        message: typeof message === "string" ? message : JSON.stringify(message),
        customPad: height,
      };
      console.log("selectedToast: ", selectedToast);
      // to limit the number of toast messages
      if (toast?.length === 5) {
        return {
          ...state,
        };
      }
      return {
        ...state,
        toast: [...toast, selectedToast],
      };
    case REMOVE_TOAST_MESSAGE:
      const removeToasts = state.toast.filter((item) => item.id !== action.payload);
      return {
        ...state,
        toast: removeToasts,
      };

    // Actionable pop
    case POPUP_CONFIRM:
      return {
        ...state,
      };
    case ADD_ACTIONABLE_POP_UP:
      const { popUp } = state;
      const selectedPopUp = {
        id: action?.payload?.id || Date.now(),
        type: action?.payload?.type,
        affirmationMsg: action?.payload?.message,
        popUpType: action?.payload?.popUpType,
      };
      console.log("selectedPopUp: ", selectedPopUp);
      return {
        ...state,
        popUp: [...popUp, selectedPopUp],
      };

    case REMOVE_ACTIONABLE_POP_UP:
      const removePopUp = state.popUp.filter((item) => item.id !== action.payload);
      return {
        ...state,
        popUp: removePopUp,
      };

    case ADD_CHARGER_TO_LOCATION_MAP:
      return {
        ...state,
        chargerToLocationMap: action.payload,
      };

    default:
      return state;
  }
};

export default sharedData;
